import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { GalleryItem } from '../../../core/services/database.service';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss']
})
export class ImageSliderComponent {
  @Input() items: GalleryItem[] = [];
  @Input() selectedCategory = 'All';
  @Output() categoryChange = new EventEmitter<string>();
  activeIndex = 0;
  imageIndex = 0;
  startX = 0;
  currentItem?: GalleryItem;

  get visibleItems(): GalleryItem[] {
    return this.selectedCategory === 'All'
      ? this.items
      : this.items.filter((item) => item.category === this.selectedCategory);
  }

  get currentImages(): string[] {
    return this.currentItem?.images?.length ? this.currentItem.images : (this.currentItem?.url ? [this.currentItem.url] : []);
  }

  get currentImage(): string {
    return this.currentImages[this.imageIndex] || this.currentItem?.url || '';
  }

  ngOnChanges(): void {
    if (this.visibleItems.length) {
      this.currentItem = this.visibleItems[this.activeIndex] || this.visibleItems[0];
      this.imageIndex = 0;
    }
  }

  previous(): void {
    if (!this.currentImages.length) { return; }
    this.imageIndex = this.imageIndex > 0 ? this.imageIndex - 1 : this.currentImages.length - 1;
  }

  next(): void {
    if (!this.currentImages.length) { return; }
    this.imageIndex = this.imageIndex < this.currentImages.length - 1 ? this.imageIndex + 1 : 0;
  }

  select(index: number): void {
    this.activeIndex = index;
    this.currentItem = this.visibleItems[index];
    this.imageIndex = 0;
  }

  switchCategory(category: string): void {
    this.selectedCategory = category;
    this.categoryChange.emit(category);
    this.activeIndex = 0;
    this.currentItem = this.visibleItems[0];
    this.imageIndex = 0;
  }
 
  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    this.startX = event.touches[0].clientX;
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent): void {
    const delta = event.changedTouches[0].clientX - this.startX;
    if (delta > 60) {
      this.previous();
    } else if (delta < -60) {
      this.next();
    }
  }
}
